import EventoServer, { connettiSignalR } from 'framework-ui-components/Components/EventoServer';


connettiSignalR(window.datiUtente.IdentificativoUtente);

export default EventoServer;
